import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from "@mui/material";

const PolicyDocumentModal = ({ open, onClose, title, url }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {url ? (
          <Box sx={{ width: "100%", height: "70vh" }}>
            <iframe
              src={url}
              title={title}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
            />
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
            This document is not available online yet. Please contact TRIP TRIP support for a copy.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PolicyDocumentModal;
